<template>
  <div>
    <v-card-text class="text-body-1 question" v-html="question.question_text"></v-card-text>
    <v-card-text class="text-body-1 question" v-if="isOnlyOneAnswerCorrect || hasNoAnswers ? false : !question.hide_multiple_info"
      >{{ $t('el.moreThanOneAnswer') }}
    </v-card-text>
    <v-card-text>
      <div v-if="revealSolution" style="position: absolute; right: 74px; transform: translateY(-23px)">Lösung</div>
      <div>
        <div v-for="answer in answersForQuestion" :key="answer.id" class="d-flex align-center pl-3 mb-2 px-4" :class="`border-${themeName}`">
          <v-checkbox
            :color="theme.elements.activeColor"
            :readonly="revealSolution || areAnswers_freezed"
            style="width: 100%"
            v-model="userAnswersById[answer.id]"
            :label="answer.answer_text"
          ></v-checkbox>

          <!-- Solution for Checkboxes -->
          <el-answer-solution :answer="answer" :revealSolution="revealSolution" :isCorrectAnswer="isCorrectAnswer(answer)" />
        </div>
      </div>
    </v-card-text>
    <v-card-text class="d-flex justify-end mr-4" style="height: 54px">
      <div v-if="revealSolution" class="d-flex text-right caption font-weight-medium">{{ resultSummary }} <br />{{ $t('el.readOnly') }}</div>
      <div v-else-if="areAnswers_freezed" class="d-flex text-right caption text--error font-weight-medium">
        {{ $t('el.answeredReadOnly') }}
      </div>
    </v-card-text>
    <transition name="slide">
      <v-card-text v-if="revealSolution && question.solution_text">
        <div :class="`border-${themeName}`" class="pa-4 mb-4" v-html="question.solution_text"></div>
        <div :class="`border-${themeName}`" class="d-flex img align-center">
          <v-img v-if="revealSolution && solutionImageUrl" width="100%" contain :src="solutionImageUrl" />
        </div>
      </v-card-text>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import commonMixin from '@/mixins/common';
import ElAnswerSolution from '@/modules/elearning/components/ElearningAnswerSolution.vue';

export default {
  name: 'ElQuestionAnswers',
  components: { ElAnswerSolution },
  mixins: [commonMixin],
  props: {
    question: Object,
    solutionImageUrl: String,
    answersForQuestion: Array,
    revealSolution: Boolean,
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      userAnswersById: {},
      radioSelectedAnswerId: null,
    };
  },
  computed: {
    ...mapState('elearning', ['answers', 'userAnswersByQuestionId']),
    //Form is valid when at least one answer is checked.
    isValid() {
      let answered = this.answersForQuestion.filter((answer) => (this.userAnswersById[answer.id] ? true : false));
      console.debug('check if answers are valid (at least one selected)', answered.length);
      return answered.length > 0;
    },
    resultSummary() {
      let correctAnswerIds = this.answersForQuestion.filter((answer) => {
        return this.isCorrectAnswer(answer);
      });
      return `${correctAnswerIds.length} richtig, ${this.answersForQuestion.length - correctAnswerIds.length} falsch`;
    },
    areAnswers_freezed() {
      let userAnswers = this.userAnswersByQuestionId[this.question.id];
      return userAnswers ? userAnswers._freezed : false;
    },
    userAnswers() {
      return this.userAnswersByQuestionId[this.question.id];
    },
    isOnlyOneAnswerCorrect() {
      const correctItems = this.answersForQuestion.filter((answer) => answer.is_correct === 1);
      return correctItems.length === 1;
    },
    hasNoAnswers() {
      return !this.answersForQuestion || this.answersForQuestion.length === 0;
    },
  },
  methods: {
    init() {
      // Initialize both types of answers
      this.answersForQuestion.forEach((answer) => {
        this.$set(this.userAnswersById, answer.id, false);
      });
    },
    // return   this.$store.getters['elearning/getModuleStatistics'](module);(userAnswersById, expectedAnswer)
    isCorrectAnswer(answer) {
      return this.$store.getters['elearning/isCorrectAnswer'](this.userAnswersById, answer);
    },
    toggleCheckbox(answerId) {
      if (this.userAnswersById[answerId] === true) {
        Vue.set(this.userAnswersById, answerId, false);
      } else {
        Vue.set(this.userAnswersById, answerId, true);
      }
      this.$store.commit('elearning/setUserAnswer', {
        questionId: this.question.id,
        answersByAnswerId: this.userAnswersById,
      });
    },
  },

  watch: {
    userAnswersById(newValue, oldValue) {
      console.debug('userAnswersById changed', newValue);

      this.$store.commit('elearning/setUserAnswer', {
        questionId: this.question.id,
        answersByAnswerId: this.userAnswersById,
      });
    },
    isValid(newValue, oldValue) {
      console.debug('detected isValid change', newValue);
      this.$emit('onAnswersValidityChange', newValue);
    },
    radioSelectedAnswerId(newValue, oldValue) {
      console.debug('radioSelectedAnswerId changed ', newValue);
      // Clear the previous radio selection, if any
      if (oldValue) {
        Vue.set(this.userAnswersById, oldValue, false);
      }
      // Set the new radio selection
      Vue.set(this.userAnswersById, newValue, true);

      this.$store.commit('elearning/setUserAnswer', {
        questionId: this.question.id,
        answersByAnswerId: this.userAnswersById,
      });
    },
  },
};
</script>
<style scoped>
.border-light,
.border-dark {
  border-radius: 15px;
  overflow: hidden;
}

.border-light {
  background: #f0f0f0;
}

.border-dark {
  background: #303030;
}

.radio-button-container {
  margin: 20px 0 !important;
}
</style>
